<!--
 * @Descripttion: 
 * @version: 
 * @Author: zhouxh
 * @Date: 2023-05-22 16:56:12
-->
<template>
    <div class="rdGroup-container">
  
      <div class="submenu-wrapper">
        <Submenu 
        :engLabel="englabel"
        :cnLabel="cnLabel"
        :linkData="linkData"
      />
      </div>
  
      <div class="main-wrapper py-2 py-md-5 px-2">
          <!-- 研发团队 -->
        <div class="img-wrapper">
          <!-- <p class="split-header">研发团队</p> -->
          <div class="row justify-content-center">
            <div class="col-12 col-xl-8">
              <ImageLoader 
                :src="img"
                :height="imgHeight"
                fit="fill"
                />
            </div> 
         </div>
        </div>

        <div class="patent-wrapper ">

           <div>
                <p class="split-header">研发专利</p>
                <p class="patent-title article-paragraph">
                 拥有90多项国家专利，包括20多项发明专利，30多项实用新型专利，6项软件著作权，剩余多项专利未来将要授权。
                </p>
           </div>

            <div class="row justify-content-start justify-content-md-center mt-3">
                  <!-- <div class="col-12 col-md-4 col-lg-3 my-2 mx-1 mx-md-2" v-for="item in patentData" :key="item">
                    <div class="patent-img my-2 my-md-4">
                        <ImagePreview
                          :src="item"
                          :height="398"
                          :width="308"
                          :previewurl="getPreviewurl(item)"
                          fit="fill"
                        />

                    </div>
                </div> -->

                <div class="col-12 col-xl-8 col-md-4 col-lg-3 my-2 mx-1 mx-md-2">
                    <div class="carousel-wrapper" style="height: 800px;margin: 20px auto;">
                        <Patent 
                        :carouselData="parentData"  
                        :interval="3000" 
                        :autoplay="false" />
                    </div>
                </div>
             </div>

        </div>

        <!-- 研发服务 -->
        <div class="img-wrapper">
          <!-- <p class="split-header">研发服务</p> -->
          <div class="row justify-content-center">
            <div class="col-12 col-xl-8 ">
              <ImageLoader 
                :src="img2"
                :height="img2Height"
                fit="fill"
                />
            </div> 
         </div>
        </div>


        <!-- 研发质量 -->
        <div class="img-wrapper">
          <!-- <p class="split-header">研发质量</p> -->
          <div class="row justify-content-center">
 
             <div class="col-12 col-xl-8 ">
              <ImageLoader 
                :src="img3"
                :height="img3Height"
                fit="fill"
                />
            </div>
         </div>
        </div>
  
      </div>
  
    </div>
  </template>
  
  <script>
  import Patent from "@/components/Patent";
  import { AboutLink } from "@/assets/js/submenulink.js";
  import Submenu from "@/components/Submenu/";
  import ImageLoader from "@/components/ImageLoader/";
  import ImagePreview from "@/components/ImagePreview";
  export default {
     components: {
      Submenu,
      ImageLoader,
      ImagePreview,
      Patent
     },
    
     data() {
      return {
        englabel: 'ABOUT US',
        cnLabel: '关于东久电子',
        imgHeight: 732,

        parentHeight: 400,//专利组件的初始高度
        img_aspect_ratio: (1372 / 732).toFixed(2),

        img2Height: 660,
        img2_aspect_ratio: (1367 / 660).toFixed(2),

        img3Height: 753,
        img3_aspect_ratio: (1361 / 753).toFixed(2),

        windowSize: {},
        linkData: [],
        // patentData:[
        //     require("@/assets/img/About/yanfatuandui/patent1.png"),
        //     require("@/assets/img/About/yanfatuandui/patent2.png"),
        //     require("@/assets/img/About/yanfatuandui/patent3.png"),
        //     require("@/assets/img/About/yanfatuandui/patent4.png"),
        //     require("@/assets/img/About/yanfatuandui/patent5.png"),
        //     require("@/assets/img/About/yanfatuandui/patent6.png")
        // ],

        parentData: [
            {title:'安全气囊控制器软件著作权',imgurl: require("@/assets/img/About/parent/01安全气囊控制器软件著作权.png")},
            {title:'车窗防夹控制器软件著作权',imgurl: require("@/assets/img/About/parent/02车窗防夹控制器软件著作权.png")},
            {title:'车门控制器软件DCU著作权',imgurl: require("@/assets/img/About/parent/03车门控制器软件DCU著作权.png")},
            {title:'车门控制器软件著作权',imgurl: require("@/assets/img/About/parent/04车门控制器软件著作权.png")},
            {title:'车身控制器软件著作权',imgurl: require("@/assets/img/About/parent/05车身控制器软件著作权.png")},
            {title:'座椅控制器软件著作权',imgurl: require("@/assets/img/About/parent/06座椅控制器软件著作权.png")},
            {title:'07',imgurl: require("@/assets/img/About/parent/07.png")},
            {title:'08',imgurl: require("@/assets/img/About/parent/08.png")},
            {title:'09',imgurl: require("@/assets/img/About/parent/09.png")},
            {title:'10',imgurl: require("@/assets/img/About/parent/10.png")},
            {title:'11',imgurl: require("@/assets/img/About/parent/11.png")},
            {title:'12',imgurl: require("@/assets/img/About/parent/12.png")},
            {title:'13',imgurl: require("@/assets/img/About/parent/13.png")},
            {title:'14',imgurl: require("@/assets/img/About/parent/14.png")},
            {title:'15',imgurl: require("@/assets/img/About/parent/15.png")},
            {title:'16',imgurl: require("@/assets/img/About/parent/16.png")},
            {title:'17',imgurl: require("@/assets/img/About/parent/17.png")},
            {title:'18',imgurl: require("@/assets/img/About/parent/18.png")},
            {title:'19',imgurl: require("@/assets/img/About/parent/19.png")},
            {title:'20',imgurl: require("@/assets/img/About/parent/20.png")},
            {title:'21',imgurl: require("@/assets/img/About/parent/21.png")},
            {title:'22',imgurl: require("@/assets/img/About/parent/22.png")},
            {title:'23',imgurl: require("@/assets/img/About/parent/23.png")},
            {title:'24',imgurl: require("@/assets/img/About/parent/24.png")},
            {title:'25',imgurl: require("@/assets/img/About/parent/25.png")},
            {title:'26',imgurl: require("@/assets/img/About/parent/26.png")},
            {title:'27',imgurl: require("@/assets/img/About/parent/27.png")},
            {title:'28',imgurl: require("@/assets/img/About/parent/28.png")},
            {title:'29',imgurl: require("@/assets/img/About/parent/29.png")},
            {title:'30',imgurl: require("@/assets/img/About/parent/30.png")},
            {title:'31',imgurl: require("@/assets/img/About/parent/31.png")},
            {title:'32',imgurl: require("@/assets/img/About/parent/32.png")},
            {title:'33',imgurl: require("@/assets/img/About/parent/33.png")},
            {title:'34',imgurl: require("@/assets/img/About/parent/34.png")},
            {title:'35',imgurl: require("@/assets/img/About/parent/35.png")},
            {title:'36',imgurl: require("@/assets/img/About/parent/36.png")},
            {title:'37',imgurl: require("@/assets/img/About/parent/37.png")},
  
         ],
        img: require("@/assets/img/About/yanfatuandui/yanfatuandui.png"),
        img2: require("@/assets/img/About/yanfatuandui/quality1.png"),
        img3: require("@/assets/img/About/yanfatuandui/quality2.png"),


      }
    },
  
    created() {
        this.getWindowSize();
        this.linkData = AboutLink;
     },
  
  
    mounted() {
        //拉伸窗口时触发
        window.onresize = () => {
            this.getWindowSize();
            
        }
  
    },
     methods: {
      getPreviewurl(item){
         return [item];
       },
      getWindowSize() {
           this.windowSize.width =   document.documentElement.clientWidth || document.body.clientWidth; 
           this.windowSize.Height =  document.documentElement.clientHeight || document.body.clientHeight; 
           this.imgHeight =  Math.round(this.windowSize.width / this.img_aspect_ratio); 
           this.img2Height = Math.round(this.windowSize.width / this.img2_aspect_ratio); 
          },
     }
  
  
  }
  </script>
  
  <style scoped lang="less">
  @import "~@/styles/global.less";
    .rdGroup-container{
      position: relative;;
      width: 100%;;
      height: auto;
      //继承通用属性
      .general-layout;
  
        .patent-wrapper{
           margin: 4rem 0;
          .patent-title{
            text-align: center;
            font-size: 1.2rem;
          }

          @media (max-width: 576px){
            .patent-title{
                text-align: start;
                font-size: 0.9rem;
              }
          }

          
          .patent-img{
            width: 100%;
            text-align: center;
            .image-preview-container{
                border:1px solid @lightWords;
                display: inline-block;
            }
          }
           
        }
  
  

    }
  
  </style>